module.exports = __webpack_public_path__ + "static/media/Solomon Islands - SB.2586d892.png";